import React from "react";
import { Plural } from "@lingui/macro";
import * as styles from "./CruiseItineraryPortsSummary.module.scss";
import { Icon } from "@silversea-ssc/ui-components-react";

export interface CruiseItineraryPortsSummaryProps {
  ports?: number;
  countries?: number;
  routesCount?: number;
}

const CruiseItineraryPortsSummary: React.FC<CruiseItineraryPortsSummaryProps> = ({
  ports,
  countries,
  routesCount
}) => {
  return (
    <ul className={styles.list}>
      <li className={styles.item}>
        <Icon name="anchor" padding="inline" size="1.5x" />{" "}
        <Plural value={ports} one="# Port" other="# Ports" />
      </li>
      {routesCount && routesCount > 0 && (
        <li className={styles.item}>
          <Icon name="routes-2" padding="inline" size="1.5x" />{" "}
          <Plural value={routesCount} one="# Route" other="# Routes" />
        </li>
      )}
      <li className={styles.item}>
        <Icon name="flag" padding="inline" size="1.5x" />{" "}
        <Plural value={countries} one="# Country" other="# Countries" />
      </li>
    </ul>
  );
};

export default CruiseItineraryPortsSummary;
